import m from "mithril";
import {ScannerItem} from "../../model/items/ScannerItem";
import {simpleContent} from './helpers'
import {Vnode} from "mithril";

export class ScannerItemView {
    public static component = {
        view: (vnode :Vnode) => {
            return m(ScannerItemView, vnode.attrs);
        }
    };

    private cellItem: ScannerItem;

    constructor(attr: any) {
        this.cellItem = <ScannerItem>attr.cellItem;
    }

    onClick() {
        this.cellItem.set(<string>window.prompt(''))
    }

    view(): any {
        const text = this.cellItem.questionary.messages.get(this.cellItem.getVariable() ? 'scannerStateFilled' : 'scannerStateEmpty');
        return m('div',
            m('button.scanner.'+this.cellItem.getType()+(this.cellItem.getVariable() ? '.filled' : ''), {
                    onclick: () => this.onClick()
                },
                simpleContent(this.cellItem, this.cellItem.childrenTags)
            ),
            m('div', text)
        );
    }
}